import api from '../api';

const removeIp = async (params = {}) => {
    const { data } = await api.post('/api/meerkat-vpn-operations/remove-ip', {}, { params });
    return data;
};

const assignIp = async (params = {}) => {
    const { data } = await api.post('/api/meerkat-vpn-operations/assign-ip', {}, { params });
    return data;
};

const getMeerkatListByEid = async (eid, params) => {
    const { data } = await api.get(`/api/meerkat-vpn-operations/list/${eid}`, { params });
    return data;
};

const enablePublicIp = async (params) => {
    const { data } = await api.post(`/api/meerkat-vpn-operations/enable-public-vpn`, {}, { params });
    return data;
};


const MeerkatService = {
    getMeerkatListByEid,
    removeIp,
    assignIp,
    enablePublicIp
};

export default MeerkatService;
